angular.module(appConfig.appName, appConfig.appDependencies);